/**
 * ============================================================
 * GENDER TOGGLE — Shopify Horizon Theme
 * File: assets/gender-toggle.js
 *
 * Horizon uses native Custom Elements (Web Components) and
 * avoids jQuery or heavy frameworks. We follow the same pattern.
 * ============================================================
 */

(function () {
  'use strict';

  const STORAGE_KEY  = 'clothing_gender_pref';
  const DEFAULT      = 'men';

  /* ── Helpers ── */
  function getStored() {
    try { return localStorage.getItem(STORAGE_KEY) || DEFAULT; }
    catch { return DEFAULT; }
  }

  function store(gender) {
    try { localStorage.setItem(STORAGE_KEY, gender); }
    catch { /* storage blocked */ }
  }

  /* ── Core switch logic ── */
  function applyGender(gender) {
    /* 1. Update all toggle buttons on the page (header may render twice on mobile) */
    document.querySelectorAll('.gender-btn[data-gender]').forEach(btn => {
      const isActive = btn.dataset.gender === gender;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    /* 2. Show / hide homepage sections */
    document.querySelectorAll('[data-gender-section]').forEach(el => {
      const match = el.dataset.genderSection === gender;
      el.classList.toggle('gender-section--visible', match);
    });

    /* 3. Persist choice */
    store(gender);

    /* 4. Fire custom event for any other scripts that need to react */
    document.dispatchEvent(
      new CustomEvent('gender:changed', {
        bubbles: true,
        detail: { gender }
      })
    );
  }

  /* ── Custom Element — <gender-toggle> ── */
  /* Horizon uses custom elements; this follows that convention. */
  class GenderToggle extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.gender-btn[data-gender]').forEach(btn => {
        btn.addEventListener('click', () => applyGender(btn.dataset.gender));
      });
    }
  }

  /* Register only if not already defined */
  if (!customElements.get('gender-toggle')) {
    customElements.define('gender-toggle', GenderToggle);
  }

  /* ── Fallback: plain event delegation for non-custom-element usage ── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.gender-btn[data-gender]');
    if (btn) applyGender(btn.dataset.gender);
  });

  /* ── Init on DOMContentLoaded ── */
  function init() {
    applyGender(getStored());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Public API (optional) ── */
  window.GenderToggle = { switch: applyGender, current: getStored };
})();
